import React from "react";
import { Content } from "./Content";
import { Header } from "../../Header";
import cname from "../style.module.scss";
import "../SpectrophotometerInfoModal/style.scss";
import {
  FullscreenModal,
  CloseButton,
} from "@learningblocks/storybook-components/lib/FullscreenModal";

/**
 * Props for the PrincipleOfSpectrophotometerModal component
 */
interface WhatIsLightModalProps {
  /**
   * Whether the modal window is open
   */
  isOpen: boolean;
  /**
   * Function to call when closing the modal window
   */
  onClose: () => void;
  /**
   * Whether the notebook is collapsed
   */
  notebookCollapsed: boolean;
  /**
   * size of  header
   */
  size?: "sm" | "md" | "lg";
}

/**
 * PrincipleOfSpectrophotometerModal:
 *  - Give user general info on Spectrophotometer and
 *    its working
 */
export function SpectrophotometerTroubleshootModal(
  props: WhatIsLightModalProps
) {
  return (
    <FullscreenModal
      isOpen={props.isOpen}
      className={`${cname.whatIsLightModal}`}
      notebookExpanded={!props.notebookCollapsed}
      close={props.onClose}
    >
      <div className={cname.backButton}>
        <CloseButton close={props.onClose} backLabel="Lab" />
      </div>
      <div className={cname.container}>
        <Header className={cname.header} label="" size={props.size} />
        <div className={cname.section}>
          <Content />
        </div>
      </div>
    </FullscreenModal>
  );
}
